<template>
  <f7-page
    @page:afterin="initReader"
    @page:beforeout="stopReader"
  >
    <div class="max-w-xl mx-auto px-4">
      <div class="flex justify-end items-center">
        <a
          v-if="!isAdmin"
          class="absolute left-0 m-5 rounded-full shadow-lg p-2 leading-3"
          @click.prevent="$f7router.back()"
        >
          <eva-icon
            name="arrow-back-outline"
            fill="#6C63FF"
            width="32"
            height="32"
          />
        </a>
        <button
          type="submit"
          :class="`flex justify-start w-48 ${qrButtonColor} text-white text-2xl rounded-md my-4 p-4`"
          @click="changeScanningState"
        >
          <eva-icon
            :name="qrButtonIcon"
            fill="#FFFFFF"
            width="32"
            height="32"
          />
          <span class="ml-4">
            {{ qrButtonMessage }}
          </span>
        </button>
      </div>
      <ValidationObserver
        v-if="!scanning"
        ref="form"
      >
        <form
          id="myForm"
          class="w-full max-w-xl p-4 mx-auto rounded-md shadow-md text-lg"
          @submit="$event.preventDefault()"
        >
          <ValidationProvider
            v-slot="{ errors }"
            vid="personSearch"
            name="Documento"
            :rules="{ regex: /^[0-9a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\- .' ]*$/ }"
          >
            <label
              for="documentID"
            >Documento o nombre:</label>
            <input
              id="documentID"
              ref="documentID"
              name="personSearch"
              type="text"
              class="rounded-lg w-full text-2xl border border-gray-400 focus:bg-gray-200 p-2"
              :value="searchValue"
              @input="searchValue = $event.target.value"
            >
            <p class="bg-red-400 text-lg text-white text-center rounded-b-lg mx-1">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <a
        v-if="!isSearching && !scanning"
        class="cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-4"
        @click="createGuest"
      >
        <eva-icon
          name="plus-outline"
          fill="#FFFFFF"
        />
        <div
          class="block-inline text-center w-full text-xl"
        >
          Registrar invitado
        </div>
      </a>
      <div
        v-if="isSearching && noResults"
        class="mt-10 p-4 bg-gray-100 text-xl text-center"
      >
        Sin resultados
        <a
          class="cursor-pointer text-white bg-purple-500 flex px-4 py-2 rounded-md items-center text-md my-4"
          @click="createGuest"
        >
          <eva-icon
            name="plus-outline"
            fill="#FFFFFF"
          />
          <div
            v-if="!scanning"
            class="block-inline text-center w-full"
          >
            Registrar invitado
          </div>
        </a>
      </div>
      <div
        v-if="!listReady && isSearching"
        class="mt-10"
      >
        <svg
          id="loader"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="50"
            cy="50"
            r="45"
          />
        </svg>
      </div>
      <!-- <video
        ref="videoElem"
        playsinline
        disablepictureinpicture
        :class="`w-full max-w-md mx-auto mb-10 mt-0 rounded-lg z-0 ${listReady ? 'absolute pointer-events-none' : ''}`"
      /> -->
      <div
        v-show="scanning"
        id="reader"
      />
      <div
        v-if="listReady"
        class="w-full max-w-xl mx-auto"
      >
        <div
          v-for="person in personsRead"
          :key="person.id"
        >
          <person-access
            :personName="person.name"
            :personID="person.id"
            :personalCode="person.personalCode"
            :qrInfo="person.qrInfo"
            :rules="rules"
            @auto-registered="handleAutoRegister"
          />
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'
import { db } from '../utils/firebase'
import PersonAccess from '../components/personAccess'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { MeiliSearch } from 'meilisearch'
// import QrScanner from 'qr-scanner'

export default {
  components: {
    PersonAccess,
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      searchValue: '',
      qrScanner: null,
      scanning: false,
      isSearching: false,
      personsRead: [],
      noResults: false,
      index: null,
      cancelQR: false,
      html5QrCode: null,
      rules: {},
      rulesBind: null,
      lastQrInfo: 'null',
    }
  },
  computed: {
    qrButtonIcon () {
      if (this.listReady) {
        return 'backspace-outline'
      } else {
        return this.scanning ? 'close-square-outline' : 'grid-outline'
      }
    },
    qrButtonColor () {
      if (this.listReady) {
        return 'bg-green-500'
      } else {
        return this.scanning ? 'bg-red-500' : 'bg-purple-500'
      }
    },
    qrButtonMessage () {
      if (this.listReady) {
        return 'limpiar'
      } else {
        return this.scanning ? 'Cancelar' : 'Escanear'
      }
    },
    listReady () {
      return this.personsRead.length > 0 || this.noResults
    },
    ...mapState({
      isAdmin: state => state.auth.isAdmin,
      instanceID: state => state.access.instanceID,
    }),
  },
  watch: {
    searchValue: async function (val) {
      if (val !== '') {
        // search value
        this.isSearching = true
        if (this.index) {
          this.parseResults(await this.index.search(val, { limit: 5 }))
        }
      } else {
        this.cleanRead()
      }
    },
  },
  mounted () {
    // if (this.$f7.device.ios) {
    this.html5QrCode = new Html5Qrcode('reader')
    // } else {
    //   const QrScannerWorkerPath = `${process.env.BASE_URL}qr-scanner-worker.min.js`
    //   QrScanner.WORKER_PATH = QrScannerWorkerPath
    //   this.videoElem = document.getElementById('qr-video')
    // }
    const client = new MeiliSearch({
      apiKey: '9b03bdcfaded919f2a6e38190e8c3a6cf559c3de3010d34170582d719c54f8fa',
      host: 'https://busqueda.cuidarte.co',
    })
    this.index = client.index(this.instanceID)
    if (this.rulesBind === null) {
      this.rulesBind = db.collection('instances').doc(this.instanceID).collection('rules').onSnapshot(snap => {
        if (!snap.empty) {
          snap.docChanges().forEach(change => {
            if (change.type === 'added' || change.type === 'modified') {
              this.$set(this.rules, change.doc.id, {
                id: change.doc.id,
                ...change.doc.data(),
              })
            } else {
              this.$delete(this.rules, change.doc.id)
            }
          })
        }
      }, (err) => { console.info(err.code) })
    }
  },
  beforeDestroy () {
    if (this.rulesBind !== null) this.rulesBind()
  },
  methods: {
    handleAutoRegister (qrInfo) {
      setTimeout(() => {
        this.changeScanningState()
        this.changeScanningState()
      }, 1000)
    },
    createGuest () {
      this.$store.commit('admin/setDocumentIDtoCreate', this.searchValue)
      this.$f7router.navigate('/guest/')
    },
    parseResults (results) {
      if (this.isSearching) {
        if (results.hits.length) {
          this.noResults = false
          this.personsRead = results.hits.map(hit => {
            return { id: hit.personID, name: hit.name }
          })
        } else {
          this.noResults = true
          this.personsRead = []
        }
      }
    },
    changeScanningState () {
      if (this.cancelQR) return
      if (this.listReady) {
        this.cleanRead()
      } else {
        if (!this.scanning) {
          this.scanning = true
          this.$nextTick(() => {
            // if (this.$f7.device.ios) {
            this.html5QrCode.start({ facingMode: 'environment' }, { fps: 10, qrbox: 200 }, this.parseCode, this.qrError)
              .catch(err => {
                console.error(err)
              })
            // } else {
            //   this.qrScanner.start().then(
            //     () => {
            //       this.hasCamera = true
            //     },
            //     (error) => {
            //       console.error(error)
            //       this.hasCamera = false
            //     }
            //   )
            // }
          })
        } else {
          // if (this.$f7.device.ios) {
          this.stopReader()
          this.scanning = false
          // } else {
          //   this.qrScanner.stop()
          // }
          this.cancelQR = true
          setTimeout(() => {
            // if (!this.$f7.device.ios) {
            //   this.scanning = false
            // }
            this.cancelQR = false
          }, 500)
        }
      }
    },
    initReader () {
      // if (!this.$f7.device.ios) {
      //   this.qrScanner = new QrScanner(this.$refs.videoElem, this.parseCode)
      // }
    },
    qrError (err) {
      // if (this.$f7.device.ios) {
      if (err.indexOf('find enough finder patterns') < 0) console.error(err)
      // } else {
      //   console.error(err)
      // }
    },
    stopReader () {
      // if (this.$f7.device.ios) {
      if (this.html5QrCode && this.scanning) {
        this.html5QrCode.stop().then(ignore => {
          // QR Code scanning is stopped.
        }).catch(err => {
          console.error(err)
        })
      }
      // } else {
      //   if (this.qrScanner) {
      //     this.qrScanner.destroy()
      //     this.qrScanner = null
      //     this.cleanRead()
      //     this.scanning = false
      //   }
      // }
    },
    cleanRead () {
      this.isSearching = false
      this.personsRead = []
      this.searchValue = ''
      this.noResults = false
      this.$nextTick(() => {
        this.$refs.documentID.focus()
      })
    },
    isNumeric (value) {
      return /^-?\d+$/.test(value)
    },
    async parseCode (code) {
      console.info(code)
      if (code.slice(0, 2) === 'c_' || code.slice(0, 3) === 'cp_') {
        // Cuidarte code
        const qrInfo = code.split('_')[1]
        if (qrInfo === this.lastQrInfo) {
          return
        }
        this.$f7.dialog.preloader('Consultando...')
        let personalCode = code.substr(0, 2) === 'cp'
        let persons
        if (personalCode) {
          persons = await db.collection('instances').doc(this.instanceID).collection('persons').where('documentID', '==', qrInfo).get()
        } else {
          persons = await db.collection('instances').doc(this.instanceID).collection('persons').where('phoneNumber', '==', qrInfo).get()
        }
        if (persons.docs.length === 1) {
          personalCode = true
        }
        this.changeScanningState()
        this.$f7.dialog.close()
        if (!persons.empty) {
          this.personsRead = persons.docs.map(person => {
            return { id: person.id, name: person.data().name, personalCode, qrInfo }
          })
        } else {
          this.$f7.dialog.alert('Parece que este QR no pertenece a esta institución. Es posible que el número de telefono haya sido cambiado.', 'Sin resultados.')
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
#loader {
  animation: 2s linear infinite svg-animation;
  max-width: 50px;
  margin: 0 auto 20px auto;
}

// SVG animation.
@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

// Circle styles.
circle {
  animation: 1.4s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: $primary-color;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

// Circle animation.
@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }
  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }
  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>
